import { ChangeDetectionStrategy, Component, inject, input, Input, output } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslocoDirective } from '@jsverse/transloco';
import { PlatformService } from '@ld.consumer-portal/utils';

import {
  footerEnvelopeIcon,
  footerLocationIcon,
  footerPhoneIcon,
  shareMyScreenIcon,
} from '@ld.consumer-portal/data-uri';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

export interface FooterExpert {
  headshotSrc: string;
  headshotAlt: string;
  name: string;
  role: string;
  nmlsId: string;
  phoneNumber: string;
  emailLabel: string;
  emailHref: string;
  addressLines: string[];
  showShareScreen?: boolean;
}

@Component({
  selector: 'ld-footer-expert-contact',
  imports: [SvgIconComponent, TranslocoDirective, MatProgressSpinnerModule],
  templateUrl: './footer-expert-contact.component.html',
  styleUrl: './footer-expert-contact.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterExpertContactComponent {
  private readonly platformService = inject(PlatformService);

  protected readonly isNativeMobile = this.platformService.isNativeMobile;

  @Input({ required: true }) expert!: FooterExpert;

  isShareScreenLoading = input<boolean>(false);

  readonly shareScreenClick = output<void>();

  protected readonly phoneIconSrc = footerPhoneIcon;
  protected readonly envelopeIconSrc = footerEnvelopeIcon;
  protected readonly locationIconSrc = footerLocationIcon;
  protected readonly shareScreenIconSrc = shareMyScreenIcon;

  protected get phoneHref(): string {
    return `tel:${this.expert.phoneNumber.replace(/[^0-9]/g, '')}`;
  }

  protected get hasAddress(): boolean {
    return Array.isArray(this.expert.addressLines) && this.expert.addressLines.length > 0;
  }

  protected onShareScreenClick(): void {
    this.shareScreenClick.emit();
  }
}
